module.exports = __webpack_public_path__ + "static/sc_10-70e1966f987100225e2e88ff9351de40.jpg";